<script>
import StatusComboBox from './StatusComboBox'
import CampaignObjectiveComboBox from './CampaignObjectiveComboBox'
import BudgetForm from './BudgetForm'
import SpecialAdCategoriesComboBox from './SpecialAdCategoriesComboBox'
import { formatTimestamp } from '../utils/formatTimestamp'

export default {
  name: 'CampaignSettingsForm',
  components: {
    StatusComboBox,
    CampaignObjectiveComboBox,
    BudgetForm,
    SpecialAdCategoriesComboBox
  },
  props: {
    value: { type: Object, required: true }
  },
  data() {
    return {
      formData: this.value
    }
  },
  methods: {
    update(field, value) {
      this.formData[field] = value
      this.$emit('input', this.formData)
    },
    formatTimestamp
  },
  watch: {
    value: function(oldValue, newValue) {
      this.formData = newValue
    }
  }
}
</script>

<template>
  <v-form>
    <v-text-field
      label="Custom campaign name"
      :placeholder="'outfox-' + formatTimestamp(Date.now())"
      :value="formData.name"
      @input="update('name', $event)"
    />
    <status-combo-box :value="formData.status" @input="update('status', $event)" />
    <campaign-objective-combo-box :value="formData.objective" @input="update('objective', $event)" />
    <budget-form :value="formData.budget" @input="update('budget', $event)" />
    <special-ad-categories-combo-box
      :value="formData.specialAdCategories"
      @input="update('specialAdCategories', $event)"
    />
  </v-form>
</template>
